import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UiService {
  loadingStateChanged = new Subject<boolean>();
  routeLoadingStateChanged = new Subject<boolean>();
  translationLoadingStateChanged = new Subject<boolean>();

  constructor(
    private snackbar: MatSnackBar,
    private translateSrv: TranslateService
  ) { }

  /**
   *
   * @param message Can be keys or custom string
   * @param isTranslated false by default, put to true if message is a key
   * @param ms 3000 by default
   * @param action null by default
   */
  showSnackbar(message: string, isTranslated = false, ms = 3000, action = null): void {
    if (isTranslated) {
      this.translateSrv.get(message).subscribe(text => {
        this.snackbar.open(text, action, { duration: ms });
      });
    } else {
      this.snackbar.open(message, action, { duration: ms });
    }
  }
}
